'use es6';

import tinymce from 'tinymce';
import AutoCompletePopover from '../components/AutoCompletePopover';
import { __HS_AUTO_COMPLETE } from '../constants/plugins';
import { getAutocompleteSpan } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
export function addControls(editor) {
  tinymce.canvas.addPopover(editor, __HS_AUTO_COMPLETE, {
    renderPopover: renderProps => {
      return /*#__PURE__*/_jsx(AutoCompletePopover, Object.assign({
        "data-test-id": "autocomplete-popover",
        editor: editor,
        targetNode: getAutocompleteSpan()
      }, renderProps));
    }
  });
}